import { FetchTopicsListForMerchantResponse, fetchTopicsListForMerchant } from "../surveysListApi"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../merchants/merchantHooks"

const selectTopics = (data: FetchTopicsListForMerchantResponse) => data.topics

export const useFetchSurveyTopics = () => {
    const { merchantId } = useMerchant()
    return useApiQuery(fetchTopicsListForMerchant, {
        queryName: "topics-list-for-merchant",
        dependencies: { merchantId },
        select: selectTopics,
    })
}
